import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const List = styled('ul')(({ theme }) => ({
  marginTop: '24px',
  display: 'grid',
  gap: '16px',
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.colors.white,
  textTransform: 'uppercase',
  fontWeight: 600,
  fontSize: '12px',
}));

export const ToggleWrapper = styled('div')({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  color: 'white',
  right: '86px',
  top: '-1px',
});
